import { UUID } from '@finxone-platform/shared/base-types';
import {
  BorderRadiusKeys,
  BorderStyles,
  Constants,
  WidgetNames,
  WorkflowWidgetConfig,
} from '@finxone-platform/shared/sys-config-types';

export const accountRequestListWidgetConfig = {
  widgetTypeConfig: 'new',
  uniqueId: new UUID().toString(),
  name: WidgetNames.ACCOUNT_REQUEST_LIST_WIDGET,
  widgetIconPath: 'listing',
  widgetConfiguration: {
    widgetDisplayName: 'Account Request List',
    widgetConfigDisplayName: 'Account Request List',
    attributes: {
      elementsConfig: [],
      css_config: {
        ...Constants.defaultBaseCssConfig,
        borderWidthTop: 1,
        borderWidthBottom: 1,
        borderWidthLeft: 1,
        borderWidthRight: 1,
        borderWidthUnit: 'px',
        borderRadiusTopLeft: 6,
        borderRadiusBottomLeft: 6,
        borderRadiusTopRight: 6,
        borderRadiusBottomRight: 6,
        borderStyle: BorderStyles.SOLID,
        borderClass: BorderRadiusKeys.NONE,
      },
      widgetProperties: {
        textContent: '',
      },
    },
    isRemovable: true,
  },
} as WorkflowWidgetConfig;
